import { DevWrapperComponentModule } from '../../../../components/dev-wrapper/dev-wrapper.module';
import { ExtMagento_2Page } from './ext-magento-2';
import { FlxCommonsModule } from "@questrade/flx-commons";
import { FlxDoclistComponentModule } from '../../../../components/flx-doclist/flx-doclist.module';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

@NgModule({
    declarations: [
        ExtMagento_2Page,
    ],
    imports: [
        DevWrapperComponentModule,
        FlxCommonsModule,
        FlxDoclistComponentModule,
        IonicPageModule.forChild(ExtMagento_2Page),
    ],
    exports: [
        ExtMagento_2Page
    ]
})
export class ExtMagento_2PageModule { }



// WEBPACK FOOTER //
// ./src/pages/extensions/ext-platforms/ext-magento-2/ext-magento-2.module.ts